export default __webpack_public_path__ + "static/media/clock.8536a1b3.svg";